import { render, staticRenderFns } from "./card-sender.vue?vue&type=template&id=e4115294&"
import script from "./card-sender.vue?vue&type=script&lang=js&"
export * from "./card-sender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports